import { Loader2 } from 'lucide-react';
import { cn } from 'lib/utils';

interface LoaderProps {
  className?: string;
  loaderSize?: string;
}

export default function Loader({ className, loaderSize }: LoaderProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center w-full h-[calc(100vh-6rem-4rem)]',
        className
      )}
    >
      <Loader2
        role='progressbar'
        className={cn(
          'w-10 h-10 stroke-1 text-primary animate-spin',
          loaderSize
        )}
      />
    </div>
  );
}
